import { ArrowUpRight, Mail, Phone } from "lucide-react";

export default function Contact() {
  return (
    <section id="contact" data-testid="contact-section" className="border-b border-white/10 py-16 md:py-24">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 text-center md:text-left">
        <h2 className="font-oswald uppercase text-5xl md:text-7xl lg:text-8xl font-bold leading-[0.95] max-w-5xl">
          Got <span className="font-cormorant italic font-medium normal-case lowercase text-white/70">footage?</span>
          <br />
          Let&apos;s cut.
        </h2>

        <p className="mt-8 text-white/60 max-w-xl font-manrope text-base md:text-lg leading-relaxed mx-auto md:mx-0">
          Pick the fastest way to get in touch. We respond within one business day — usually faster.
        </p>

        <div className="mt-10 flex flex-wrap items-center justify-center md:justify-start gap-4">
          <a
            href="https://cal.com/dotmkv-media-sgkgdp/30min"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-cal-cta"
            className="btn-brutal"
          >
            <Phone size={16} /> Book a Discovery Call
            <ArrowUpRight size={18} />
          </a>
          <a
            href="mailto:team@dotmkvmedia.com?subject=Project%20Inquiry%20-%20dotMKV%20Media"
            data-testid="contact-email-cta"
            className="btn-ghost"
          >
            <Mail size={16} /> Email team@dotmkvmedia.com
            <ArrowUpRight size={18} />
          </a>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-3 gap-6 md:gap-10 max-w-3xl border-t border-white/10 pt-10">
          <div>
            <p className="font-oswald uppercase text-xs tracking-widest text-white/40 mb-2">Email</p>
            <a
              href="mailto:team@dotmkvmedia.com"
              data-testid="contact-email-link"
              className="font-oswald uppercase text-base md:text-lg text-white hover:text-[#00A0E4] transition-colors break-all"
            >
              team@dotmkvmedia.com
            </a>
          </div>
          <div>
            <p className="font-oswald uppercase text-xs tracking-widest text-white/40 mb-2">Instagram</p>
            <a
              href="https://www.instagram.com/dotmkvmedia"
              target="_blank"
              rel="noopener noreferrer"
              className="font-oswald uppercase text-base md:text-lg text-white hover:text-[#00A0E4] transition-colors"
            >
              @dotmkvmedia
            </a>
          </div>
          <div>
            <p className="font-oswald uppercase text-xs tracking-widest text-white/40 mb-2">X / Twitter</p>
            <a
              href="https://x.com/dotmkvmedia"
              target="_blank"
              rel="noopener noreferrer"
              className="font-oswald uppercase text-base md:text-lg text-white hover:text-[#00A0E4] transition-colors"
            >
              @dotmkvmedia
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
